import { CSSProperties, FC, useRef } from 'react';
import './SolidButton.css';

export interface Size {
  height: number | string
  width: number | string
}

interface SolidButtonProps {
  /** To be set as the value of the CSS `width` and `height` properties, can provide string or number values, see `Size` interface */
  size?: Size
  /** To be st as the value of the CSS `margin` property */
  padding?: string
  /** The text to be displayed on the button */
  text?: string
  /** The action to be performed when the button is clicked */
  onClick: () => void
  /** To be set as the value of the CSS `background-color`, examples; hex string, rgb(n,n,n), var(--my-color-var) */
  color: string
  /** Any additional styling you want to apply to the button. Example; the color prop is set to white, so if you want to override, use this property */
  style?: CSSProperties
  /** Indicates whether the button should be disabled or not, applies opacity styling and disables fireing the onClick action */
  disabled?: boolean
  showRipple?: boolean
}

const SolidButton: FC<SolidButtonProps> = ({size, padding, text, onClick, color, style, disabled=false, showRipple=false}) => {
  
  const button = useRef<HTMLDivElement>(null)

  const properties: CSSProperties = {backgroundColor: color,...style}
  if (size) {
    properties.height = `${Number.isInteger(size.height) ? `${size.height}px` : `${size.height}`}`
    properties.width = `${Number.isInteger(size.width) ? `${size.width}px` : `${size.width}`}`
  }
  if (padding) {
    properties.padding = `${padding}`
  }

  const createRipple = (event: React.MouseEvent) => {
    if (showRipple && button.current !== null) {
      
      const circle = document.createElement('span')
      const diameter = Math.max(button.current.clientWidth, button.current.clientHeight);
      const radius = diameter / 2;
      circle.style.width = circle.style.height = `${diameter}px`;
      let offsetTop = button.current.offsetTop
      if (button.current.parentElement !== null) {
        offsetTop += button.current.parentElement.offsetTop
      }
      circle.style.left = `${event.clientX - (button.current.offsetLeft + radius)}px`;
      circle.style.top = `${event.clientY - (offsetTop + radius)}px`;
      circle.classList.add("ripple");

      const ripple = button.current.getElementsByClassName("ripple")[0];

      if (ripple) {
        ripple.remove();
      }

      button.current.appendChild(circle)
    }
    onClick()
  }

  return (
    <div 
      ref={button}
      className={`SolidButton${disabled ? ' disabled' : ''}`}
      style={properties}
      onClick={(e) => createRipple(e)}
    >
      <div className='button-title'>{text}</div>
    </div>
  )
};

export default SolidButton;
